// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__Zm3d1","Success":"Button_Success__FJR8-","Danger":"Button_Danger__3gKSl"};